import React from 'react';
import { BaseConfigProps, commonStyles } from '../shared/ConfigFormHelpers';

const NotificationConfig: React.FC<BaseConfigProps> = ({ node, updateConfig }) => {
  const notificationType = node.data.config.type || 'email';

  return (
    <div className="space-y-3">
      {/* Notification Type Cards */}
      <div>
        <label className={commonStyles.smallLabel}>
          Értesítés típusa
        </label>
        <div className="grid grid-cols-2 gap-2">
          {[
            { value: 'email', label: 'Email', icon: '📧' },
            { value: 'sms', label: 'SMS', icon: '📱' },
            { value: 'push', label: 'Push', icon: '🔔' },
            { value: 'slack', label: 'Slack', icon: '💬' }
          ].map((option) => (
            <button
              key={option.value}
              onClick={() => updateConfig('type', option.value)}
              className={`flex items-center space-x-2 p-2 rounded-md border text-sm transition-all ${
                notificationType === option.value
                  ? 'border-primary-500 bg-primary-50 dark:bg-primary-900/20 text-primary-700 dark:text-primary-300'
                  : 'border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:border-gray-400 dark:hover:border-gray-500'
              }`}
            >
              <span>{option.icon}</span>
              <span className="font-medium">{option.label}</span>
            </button>
          ))}
        </div>
      </div>
      
      {/* Email Details - csak email típusnál */}
      {notificationType === 'email' && (
        <div className="space-y-3">
          <div>
            <label className={commonStyles.label}>
              Címzett
            </label>
            <input
              type="email"
              value={node.data.config.recipient || ''}
              onChange={(e) => updateConfig('recipient', e.target.value)}
              className={commonStyles.input}
              placeholder="example@email.com vagy {{customer.email}}"
            />
          </div>

          <div>
            <label className={commonStyles.label}>
              Tárgy
            </label>
            <input
              type="text"
              value={node.data.config.subject || ''}
              onChange={(e) => updateConfig('subject', e.target.value)}
              className={commonStyles.input}
              placeholder="Email tárgy"
            />
          </div>

          <div>
            <label className={commonStyles.label}>
              Üzenet
            </label>
            <textarea
              value={node.data.config.message || ''}
              onChange={(e) => updateConfig('message', e.target.value)}
              rows={4}
              className={commonStyles.textarea}
              placeholder="Email tartalom..."
            />
          </div>
        </div>
      )}

      {/* SMS Details - csak SMS típusnál */}
      {notificationType === 'sms' && (
        <div className="space-y-3">
          <div>
            <label className={commonStyles.label}>
              Telefonszám
            </label>
            <input
              type="tel"
              value={node.data.config.phoneNumber || ''}
              onChange={(e) => updateConfig('phoneNumber', e.target.value)}
              className={commonStyles.input}
              placeholder="+36301234567 vagy {{customer.phone}}"
            />
          </div>

          <div>
            <label className={commonStyles.label}>
              Üzenet
            </label>
            <textarea
              value={node.data.config.message || ''}
              onChange={(e) => updateConfig('message', e.target.value)}
              rows={3}
              className={commonStyles.textarea}
              placeholder="SMS üzenet (max 160 karakter)"
              maxLength={160}
            />
            <p className="text-xs text-gray-500 dark:text-gray-400">
              {(node.data.config.message || '').length}/160 karakter
            </p>
          </div>
        </div>
      )}

      {/* Push Notification Details */}
      {notificationType === 'push' && (
        <div className="space-y-3">
          <div>
            <label className={commonStyles.label}>
              Cím
            </label>
            <input
              type="text"
              value={node.data.config.title || ''}
              onChange={(e) => updateConfig('title', e.target.value)}
              className={commonStyles.input}
              placeholder="Push értesítés címe"
            />
          </div>

          <div>
            <label className={commonStyles.label}>
              Üzenet
            </label>
            <textarea
              value={node.data.config.message || ''}
              onChange={(e) => updateConfig('message', e.target.value)}
              rows={2}
              className={commonStyles.textarea}
              placeholder="Push értesítés szövege"
            />
          </div>
        </div>
      )}

      {/* Slack Details */}
      {notificationType === 'slack' && (
        <div className="space-y-3">
          <div>
            <label className={commonStyles.label}>
              Csatorna
            </label>
            <input
              type="text"
              value={node.data.config.channel || ''}
              onChange={(e) => updateConfig('channel', e.target.value)}
              className={commonStyles.input}
              placeholder="#general vagy @username"
            />
          </div>

          <div>
            <label className={commonStyles.label}>
              Üzenet
            </label>
            <textarea
              value={node.data.config.message || ''}
              onChange={(e) => updateConfig('message', e.target.value)}
              rows={3}
              className={commonStyles.textarea}
              placeholder="Slack üzenet (Markdown támogatott)"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationConfig;
